define('components/editors/attachments/title/viewmodel', [
    './template.html',
    './styles.scss'
], function () {
    function ViewModel(model, info, ctx) {
        this.title = model.title.default('');

        this.ctx = ctx;
        this.model = model;
        this.element = info.element;
    }

    ViewModel.prototype.beforeInit = function () {
        ko.applyBindingsToNode(this.element, {
            'click': _.noop,
            'clickBubble': false
        });
    };

    return ViewModel;
});